const SESSION_KEY = 'ac-review-session:v1';
const EDIT_KEY = 'ac-review-edit-draft:v1:';
const statuses = {pending: 'Awaiting publication', published: 'Published', hidden: 'Not published'};
function node(tag, className = '', text = '') {
  const result = document.createElement(tag);
  if (className) result.className = className;
  if (text) result.textContent = text;
  return result;
}
function tokenFromURL(url) {return new URLSearchParams(url.hash.slice(1)).get('review_token') || url.searchParams.get('review_token') || '';}
function withoutToken(url) {
  url.searchParams.delete('review_token');
  if (new URLSearchParams(url.hash.slice(1)).has('review_token')) url.hash = url.hash.slice(1).split('&').filter((part) => !new URLSearchParams(part).has('review_token')).join('&');
  return url;
}
function date(value) {const parsed = new Date(value); return Number.isNaN(parsed.getTime()) ? '' : parsed.toLocaleDateString(undefined, {year: 'numeric', month: 'short', day: 'numeric'});}

function editorClass(Base) {
  return class ReviewEditor extends Base {
    constructor(root, manager) {
      super(root);
      this.manager = manager;
      this.currentReview = null;
      this.keep = [];
      this.existingURLs = new Map();
      this.root.findExisting = root.querySelector('[data-review-existing-photos]');
      this.root.findExisting.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-remove-existing]');
        if (!remove || this.submitting) return;
        this.keep = this.keep.filter((index) => index !== Number(remove.dataset.removeExisting));
        this.photoLimit = Math.max(0, 5 - this.keep.length);
        this.renderExistingPhotos(); this.saveDraft();
      });
    }
    loadState() {}
    restoreSession() {}
    checkInvitationFromURL() {}
    saveDraft() {
      if (!this.currentReview) return;
      try {
        sessionStorage.setItem(EDIT_KEY + this.currentReview.id, JSON.stringify({
          version: this.currentReview.updatedAt, body: this.find('body').value, displayName: this.find('name').value,
          rating: this.form.querySelector('[name="rating"]:checked')?.value || '', consent: this.find('consent').checked,
          keep: this.keep, requestId: this.editRequestId, photoCount: this.photos.length, expiresAt: Date.now() + 24 * 60 * 60 * 1000,
        }));
      } catch {}
    }
    cleanup() {
      this.photoController?.abort();
      for (const url of this.existingURLs?.values() || []) if (typeof url === 'string') URL.revokeObjectURL(url);
      this.existingURLs?.clear();
      this.photos.forEach((photo) => URL.revokeObjectURL(photo.url));
      this.photos = [];
    }
    open(review) {
      this.cleanup();
      this.currentReview = review;
      this.reviewSession = this.manager.reviewSession;
      this.keep = review.photos.map((photo) => photo.index);
      this.editRequestId = crypto.randomUUID();
      this.form.reset(); this.showError(''); this.setStatus('');
      this.manager.find('reload').hidden = true;
      this.root.setAttribute('aria-busy', 'false');
      this.find('access').hidden = true; this.find('thanks').hidden = true;
      this.find('content').hidden = false; this.form.hidden = false;
      this.find('order-field').hidden = true; this.find('item-field').hidden = true; this.find('empty').hidden = true;
      this.find('product').hidden = false;
      this.find('product-image').hidden = true; this.find('product-image').removeAttribute('src');
      this.find('order-label').textContent = review.orderLabel;
      this.find('product-title').textContent = review.productTitle;
      this.renderProductDetails?.([]);
      this.find('body').value = review.body; this.find('name').value = review.displayName;
      let rating = String(review.rating);
      try {
        const draft = JSON.parse(sessionStorage.getItem(EDIT_KEY + review.id) || 'null');
        if (draft?.version === review.updatedAt && draft.expiresAt > Date.now()) {
          this.find('body').value = typeof draft.body === 'string' ? draft.body.slice(0, 5000) : review.body;
          this.find('name').value = typeof draft.displayName === 'string' ? draft.displayName.slice(0, 120) : review.displayName;
          rating = /^[1-5]$/.test(draft.rating) ? draft.rating : rating;
          this.find('consent').checked = draft.consent === true;
          if (Array.isArray(draft.keep)) this.keep = this.keep.filter((index) => draft.keep.includes(index));
          if (/^[0-9a-f-]{36}$/i.test(draft.requestId)) this.editRequestId = draft.requestId;
          if (draft.photoCount) {this.find('photo-error').textContent = 'Your writing is saved. Please add your new photos again.'; this.find('photo-error').hidden = false;}
        } else this.find('photo-error').hidden = true;
      } catch {this.find('photo-error').hidden = true;}
      this.form.querySelectorAll('[name="rating"]').forEach((radio) => {radio.checked = radio.value === rating;});
      this.photoLimit = Math.max(0, 5 - this.keep.length);
      this.find('submit').textContent = 'Save changes →';
      this.find('body').setCustomValidity(''); this.find('name').setCustomValidity('');
      this.updateStars(); this.updateBodyCount(); this.renderPhotos(); this.renderExistingPhotos();
      const photoController = new AbortController();
      this.photoController = photoController;
      for (const photo of review.photos) {
        void this.manager.photo(review, photo.index, photoController.signal).then((blob) => {
          if (photoController.signal.aborted || this.currentReview?.id !== review.id || this.currentReview?.updatedAt !== review.updatedAt) return;
          this.existingURLs.set(photo.index, URL.createObjectURL(blob)); this.renderExistingPhotos();
        }).catch(() => {});
      }
    }
    renderExistingPhotos() {
      if (!this.root.findExisting) return;
      this.root.findExisting.replaceChildren(...this.keep.map((index) => {
        const figure = node('figure', 'ac-review-form__photo'), image = node('img');
        image.alt = `Current review photo ${index + 1}`; image.width = 84; image.height = 84;
        const url = this.existingURLs.get(index); if (url) image.src = url;
        const remove = node('button', '', '×'); remove.type = 'button'; remove.dataset.removeExisting = String(index);
        remove.setAttribute('aria-label', `Remove current photo ${index + 1}`); remove.disabled = this.submitting;
        figure.append(image, remove); return figure;
      }));
    }
    async submit(event) {
      event.preventDefault();
      if (this.submitting || !this.currentReview) return;
      this.find('body').setCustomValidity(this.find('body').value.trim() ? '' : 'Please tell us about your experience.');
      this.find('name').setCustomValidity(this.find('name').value.trim() ? '' : 'Please choose a display name.');
      if (!this.form.reportValidity()) return;
      this.saveDraft(); this.submitting = true;
      this.manager.setEditingBusy(true); this.find('fieldset').disabled = true;
      this.root.setAttribute('aria-busy', 'true'); this.find('submit').textContent = 'Saving your changes…';
      this.showError('');
      const payload = new FormData();
      for (const [key, value] of Object.entries({reviewId: this.currentReview.id, expectedUpdatedAt: this.currentReview.updatedAt, editRequestId: this.editRequestId,
        rating: this.form.querySelector('[name="rating"]:checked').value, body: this.find('body').value.trim(), displayName: this.find('name').value.trim(), consent: 'true', keepPhotos: JSON.stringify(this.keep)})) payload.set(key, value);
      this.photos.forEach((photo) => payload.append('photos', photo.file, photo.file.name));
      try {
        const result = await this.manager.request('update', payload, {multipart: true, reviewId: this.currentReview.id});
        try {sessionStorage.removeItem(EDIT_KEY + this.currentReview.id);} catch {}
        this.currentReview = null;
        this.manager.closeEditor(true);
        await this.manager.load(false, result.unchanged ? 'Your review is unchanged.' : 'Your changes were saved and are awaiting publication.');
      } catch (error) {
        if (error.status === 401 || error.status === 403) {
          this.find('access').hidden = false;
          this.showError('Your access expired. Your writing is saved. Sign in or reopen your secure review link to continue.');
          this.manager.clearSession();
        } else {
          this.showError(error.message);
          if (error.code === 'REVIEW_REVISION_CONFLICT' || error.code === 'REVIEW_EDIT_CONFLICT') this.manager.find('reload').hidden = false;
        }
      } finally {
        this.submitting = false; this.find('fieldset').disabled = false;
        this.root.setAttribute('aria-busy', 'false'); this.find('submit').textContent = 'Save changes →';
        this.manager.setEditingBusy(false);
        this.manager.checkInvitation();
      }
    }
  };
}

export class MyReviews {
  constructor(root, Editor) {
    this.root = root; this.find = (name) => root.querySelector(`[data-my-${name}]`);
    this.endpoint = root.dataset.endpoint; this.reviewSession = ''; this.reviews = new Map(); this.urls = new Set(); this.observers = new Set();
    this.cursor = null; this.loading = false; this.dialog = this.find('editor');
    this.editor = new Editor(root.querySelector('[data-ac-review-edit-form]'), this);
    this.updateLogin(); this.restoreSession();
    this.find('refresh').addEventListener('click', () => this.load());
    this.find('more').addEventListener('click', () => this.load(true));
    this.find('close').addEventListener('click', () => this.closeEditor());
    this.find('cancel').addEventListener('click', () => this.closeEditor());
    this.find('reload').addEventListener('click', async () => {
      if (this.editor.submitting || !this.editor.currentReview) return;
      this.setEditingBusy(true);
      try {
        this.editor.saveDraft();
        const result = await this.request('mine', {reviewId: this.editor.currentReview.id});
        if (!result.reviews?.[0]) throw new Error('Sign in or reopen your secure link to reload this review.');
        this.editor.open(result.reviews[0]);
        this.editor.setStatus('Latest saved version loaded. Your unsaved changes have not been applied.');
      } catch (error) {this.editor.showError(error.message);}
      finally {this.setEditingBusy(false);}
    });
    this.dialog.addEventListener('cancel', (event) => {event.preventDefault(); this.closeEditor();});
    this.find('list').addEventListener('click', (event) => {
      const button = event.target.closest('[data-edit-review]');
      if (button && this.reviews.has(button.dataset.editReview)) this.openEditor(this.reviews.get(button.dataset.editReview), button);
    });
    window.addEventListener('hashchange', () => this.checkInvitation());
    this.load();
  }
  restoreSession() {
    if (this.root.dataset.customerSignedIn === 'true') return;
    try {const saved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null'); if (saved?.kind === 'invitation' && saved.expiresAt > Date.now()) this.reviewSession = saved.token || '';} catch {}
  }
  clearSession() {this.reviewSession = ''; try {sessionStorage.removeItem(SESSION_KEY);} catch {}}
  checkInvitation() {
    if (!this.loading && !this.editor.submitting && tokenFromURL(new URL(location.href))) {this.closeEditor(); void this.load();}
  }
  updateLogin() {
    const url = withoutToken(new URL(location.href)), login = new URL(this.root.dataset.loginUrl, location.origin);
    login.searchParams.set('return_to', url.pathname + url.search + url.hash); this.find('login').href = login.href;
  }
  async request(action, body = {}, options = {}) {
    const headers = {Accept: options.photo ? 'image/*, application/json' : 'application/json'};
    if (!options.multipart) headers['Content-Type'] = 'application/json';
    if (options.multipart && this.reviewSession) headers['X-AC-Review-Session'] = this.reviewSession;
    if (options.reviewId) headers['X-AC-Review-Id'] = options.reviewId;
    const payload = options.multipart ? body : {...body, ...(this.reviewSession ? {reviewSession: this.reviewSession} : {})};
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (options.signal?.aborted) controller.abort();
    options.signal?.addEventListener('abort', abort, {once: true});
    const timeout = setTimeout(abort, options.multipart ? 120000 : 30000);
    try {
    const response = await fetch(`${this.endpoint}/${action}`, {method: 'POST', credentials: 'same-origin', cache: 'no-store', headers, body: options.multipart ? payload : JSON.stringify(payload), signal: controller.signal});
    if (options.photo && response.ok && /^image\/(jpeg|png|webp)(?:;|$)/.test(response.headers.get('Content-Type') || '')) return await response.blob();
    const data = await response.json().catch(() => null);
    if (!response.ok || data?.ok !== true) {
      const error = new Error(data?.error?.message || data?.message || 'We couldn’t complete that request. Please try again.');
      error.status = response.status; error.code = data?.error?.code || (typeof data?.error === 'string' ? data.error : ''); throw error;
    }
    if (options.photo) throw new Error('This photo could not be loaded.');
    return data;
    } catch (error) {
      if (error.name === 'AbortError' && !options.signal?.aborted) throw new Error('We couldn’t confirm the result in time. Your writing is saved; please try again.');
      throw error;
    } finally {clearTimeout(timeout); options.signal?.removeEventListener('abort', abort);}
  }
  photo(review, index, signal) {return this.request('photo', {reviewId: review.id, index, expectedUpdatedAt: review.updatedAt}, {photo: true, signal});}
  async load(more = false, notice = '') {
    if (this.loading) return;
    this.loading = true; this.root.setAttribute('aria-busy', 'true');
    const openingToken = tokenFromURL(new URL(location.href));
    this.find('refresh').disabled = true; this.find('more').disabled = true;
    this.find('error').hidden = true; this.find('access').hidden = true;
    this.find('status').textContent = notice || 'Loading your reviews…';
    if (!more) {
      this.photoController?.abort(); this.observers.forEach((observer) => observer.disconnect()); this.observers.clear();
      for (const url of this.urls) URL.revokeObjectURL(url); this.urls.clear();
      this.photoController = new AbortController(); this.find('list').replaceChildren(); this.reviews.clear();
    }
    try {
      const url = new URL(location.href), token = tokenFromURL(url);
      if (token) {
        const exchanged = await this.request('state', {token});
        if (tokenFromURL(new URL(location.href)) !== token) return;
        if (!exchanged.sessionToken) throw new Error('This review link could not be opened.');
        this.reviewSession = exchanged.sessionToken;
        try {sessionStorage.setItem(SESSION_KEY, JSON.stringify({kind: 'invitation', token: this.reviewSession, orderId: exchanged.selectedOrderId || '', expiresAt: Date.now() + 55 * 60 * 1000}));} catch {}
        if (tokenFromURL(new URL(location.href)) === token) history.replaceState(history.state, '', withoutToken(new URL(location.href)));
        this.updateLogin();
      }
      const selectedOrder = new URL(location.href).searchParams.get('order') || '';
      const orderFilter = /^[1-9]\d{0,29}$/.test(selectedOrder) ? {orderId: selectedOrder} : {};
      const data = await this.request('mine', {...orderFilter, ...(more && this.cursor ? {cursor: this.cursor} : {})});
      if (data.requiresLogin) {this.find('access').hidden = false; this.find('toolbar').hidden = true; this.find('empty').hidden = true; this.find('more').hidden = true; this.find('status').textContent = ''; return;}
      this.cursor = data.nextCursor || null;
      let reviews = data.reviews || [];
      const selected = new URL(location.href).searchParams.get('review');
      if (!more && /^ac_[0-9a-f-]{36}$/i.test(selected || '') && !reviews.some((review) => review.id === selected)) {
        try {const detail = await this.request('mine', {reviewId: selected}); reviews = [...detail.reviews.filter(review => !selectedOrder || review.orderId === selectedOrder), ...reviews];} catch {}
      }
      for (const review of reviews) {
        if (this.reviews.has(review.id)) continue;
        this.reviews.set(review.id, review); this.find('list').append(this.card(review));
      }
      this.find('toolbar').hidden = false; this.find('empty').hidden = this.reviews.size > 0;
      this.find('more').hidden = !this.cursor; this.find('status').textContent = notice;
      const editURL = new URL(location.href);
      if (!more && editURL.searchParams.get('edit') === '1' && selected && this.reviews.has(selected)) {
        editURL.searchParams.delete('edit'); history.replaceState(history.state, '', editURL);
        this.updateLogin();
        const opener = Array.from(this.find('list').querySelectorAll('[data-edit-review]')).find(button => button.dataset.editReview === selected);
        this.openEditor(this.reviews.get(selected), opener);
      }
    } catch (error) {
      this.find('error').textContent = error.message || 'We couldn’t load your reviews. Please try again.'; this.find('error').hidden = false;
      this.find('status').textContent = ''; this.find('toolbar').hidden = false;
      if (error.status === 401 || error.status === 403) {this.clearSession(); this.find('access').hidden = false;}
    } finally {
      this.loading = false; this.root.setAttribute('aria-busy', 'false');
      this.find('refresh').disabled = false; this.find('more').disabled = false;
      const latestToken = tokenFromURL(new URL(location.href));
      if (latestToken && latestToken !== openingToken) this.checkInvitation();
    }
  }
  card(review) {
    const card = node('article', 'ac-my-reviews__card'), header = node('header'), heading = node('div');
    heading.append(node('h2', '', review.productTitle), node('small', '', `${review.orderLabel} · ${date(review.createdAt)}`));
    header.append(heading, node('span', `ac-my-reviews__badge is-${review.status}`, statuses[review.status] || 'Awaiting publication'));
    const stars = node('div', 'ac-my-reviews__stars', '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating)); stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
    card.append(header, stars, node('p', 'ac-my-reviews__body', review.body));
    if (review.photos.length) {
      const photos = node('div', 'ac-my-reviews__photos'); card.append(photos);
      const signal = this.photoController.signal;
      const load = () => {
        if (signal.aborted) return;
        for (const photo of review.photos) {
          const link = node('a'), image = node('img'); image.alt = `Review photo ${photo.index + 1}`; image.width = 94; image.height = 94;
          link.target = '_blank'; link.rel = 'noopener'; link.append(image); photos.append(link);
          void this.photo(review, photo.index, signal).then((blob) => {if (signal.aborted) return; const url = URL.createObjectURL(blob); this.urls.add(url); image.src = url; link.href = url;}).catch(() => {if (!signal.aborted) link.replaceChildren(node('span', '', 'Photo unavailable'));});
        }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {if (entries.some((entry) => entry.isIntersecting)) {observer.disconnect(); this.observers.delete(observer); load();}}, {rootMargin: '180px'});
        this.observers.add(observer);
        observer.observe(photos);
      } else load();
    }
    const footer = node('footer'), edit = node('button', '', 'Edit review'); edit.type = 'button'; edit.dataset.editReview = review.id;
    footer.append(node('span', '', `Shown as ${review.displayName}`), edit); card.append(footer);
    return card;
  }
  openEditor(review, opener) {this.opener = opener; this.editor.open(review); this.dialog.showModal(); this.dialog.scrollTop = 0; this.editor.find('body').focus({preventScroll: true});}
  closeEditor(force = false) {
    if (this.editor.submitting && !force) return;
    this.editor.saveDraft(); this.editor.cleanup(); this.dialog.close();
    if (this.opener?.isConnected) this.opener.focus({preventScroll: true});
  }
  setEditingBusy(busy) {this.find('close').disabled = busy; this.find('cancel').disabled = busy; this.find('reload').disabled = busy;}
}

function initialize(scope = document) {
  scope.querySelectorAll('[data-my-reviews-root]').forEach(async (root) => {
    if (root.dataset.myReviewsReady) return;
    root.dataset.myReviewsReady = 'loading';
    try {const {AcReviewForm} = await import(root.dataset.formScriptUrl); new MyReviews(root, editorClass(AcReviewForm)); root.dataset.myReviewsReady = 'true';}
    catch {const error = root.querySelector('[data-my-error]'); error.textContent = 'The review page could not load. Please refresh and try again.'; error.hidden = false; root.setAttribute('aria-busy', 'false');}
  });
}
initialize();
document.addEventListener('shopify:section:load', (event) => initialize(event.target));
